const defaultTextValues = {
  sectionTitle: {
    en: 'Insights'
  },
  insightSubtitleOne: {
    en: 'Speakers'
  },
  insightSubtitleTwo: {
    en: 'Partners'
  },
  insightSubtitleThree: {
    en: 'Days'
  },
  insightSubtitleFour: {
    en: 'Attendees'
  },
};

export default defaultTextValues;
